import type { OpportunitiesSource, OpportunityType } from '../api/opportunities.js';

export enum RecommendationStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
}

export enum RecommendationDeclineReason {
  NOT_INTERESTED_FOR_PROFILE = 'not_interested_for_profile',
  OFF_TOPIC = 'off_topic',
  LOCATION = 'location',
  SALARY = 'salary',
  OTHER = 'other',
}

export const RECOMMENDATION_DESCRIPTION_MAX_LENGTH = 300;

export interface Recommendation {
  id: number;
  beneficiaryId: number;
  advisorId: number;
  externalId: string;
  offerSource: OpportunitiesSource;
  offerType: OpportunityType;
  offerLabel: string;
  description: string | null;
  city: string | null;
  postalCode: string | null;
  companyName: string | null;
  message: string | null;
  status: RecommendationStatus;
  declineReason: RecommendationDeclineReason | null;
  respondedAt: Date | null;
  sentAt: Date;
  createdAt?: Date;
  updatedAt?: Date;
}
